import type {
  AiExtractDataRequestPayload,
  AiExtractDataRequestResponse,
  AiExtractDataResponse,
  ExtractionTarget
} from '../api-requests/AIRequests'
import type { Ref } from 'vue'
import type { InjectionKey } from 'vue'

export interface ShowSmartPasteDialogParams {
  schemaId: ExtractionTarget
  payload: AiExtractDataRequestPayload
  options?: {
    getTextFromClipboard?: boolean
  }
}

export interface SmartPasteProviderContext {
  smartPasteData: Ref<AiExtractDataResponse | undefined>
  commands: {
    fetchSmartPasteData: (
      payload: AiExtractDataRequestPayload
    ) => Promise<AiExtractDataRequestResponse<AiExtractDataResponse>>
  }
  modals: {
    showSmartPasteDialog: (params: ShowSmartPasteDialogParams) => void
  }
}

export const SMART_PASTE_PROVIDER_KEY = Symbol(
  'smart-paste-provider'
) as InjectionKey<SmartPasteProviderContext>
